import React, { useState, useRef } from "react";
import styles from "./PeriodDropdown.module.scss";
import Icon from "../Icon/Icon";
import { useAppSelector } from "../../../redux/hooks";
import useClickOutside from "../../CustomHooks/useClickOutside";

export interface PeriodOption {
  label: string;
  value: string;
}

interface PeriodDropdownProps {
  options: PeriodOption[];
  selectedValue: string;
  onSelect: (value: string) => void;
  className?: string;
  triggerClassName?: string;
}

const PeriodDropdown: React.FC<PeriodDropdownProps> = ({
  options,
  selectedValue,
  onSelect,
  className,
  triggerClassName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useClickOutside(dropdownRef, () => setIsOpen(false));

  const selectedOption = options.find((opt) => opt.value === selectedValue);

  const handleSelect = (value: string) => {
    onSelect(value);
    setIsOpen(false);
  };

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div
      ref={dropdownRef}
      className={`${styles.period_dropdown} ${className || ""}`}
    >
      {/* Trigger Button */}
      <button
        className={`${styles.trigger_button} ${triggerClassName || ""}`}
        onClick={handleToggle}
        type="button"
      >
        <span className={styles.trigger_text}>{selectedOption?.label}</span>
        <Icon
          name="up_filled_arrow_table"
          size={12}
          color={currentTheme === "light" ? "#2C2C2C" : "#D8D8D9"}
          className={`${styles.trigger_arrow} ${isOpen ? styles.arrow_open : ""}`}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className={styles.dropdown_menu}>
          {/* Triangular tail pointing to trigger */}
          <div className={styles.dropdown_tail} />

          <div className={styles.dropdown_content}>
            {options.map((option, index) => {
              const isSelected = option.value === selectedValue;

              return (
                <div key={option.value}>
                  <div
                    className={`${styles.dropdown_item} ${
                      isSelected ? styles.selected : ""
                    }`}
                    onClick={() => handleSelect(option.value)}
                  >
                    <span
                      className={`${styles.item_label} ${
                        isSelected ? styles.selected_label : ""
                      }`}
                    >
                      {option.label}
                    </span>
                    {isSelected && (
                      <Icon
                        name="check_icon"
                        size={16}
                        color={"#38539A"}
                        className={styles.checkmark}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default PeriodDropdown;
